module.exports = __webpack_public_path__ + "img/otto-data.25e5597a.png";